import React from 'react';
import { cx } from '.';

export interface SelectItemProps {
  value: string;
  children?: React.ReactNode;
}

export const getNodeText = (
  node: React.ReactElement,
): string | React.ReactElement | undefined => {
  if (['string', 'number'].includes(typeof node)) return node;
  if (node instanceof Array) return node.map(getNodeText).join('');
  if (typeof node === 'object' && node) return getNodeText(node.props.children);
};

export function constructValueToNameMapping(
  children: React.ReactElement[] | React.ReactElement,
) {
  const valueToNameMapping = new Map<string, string>();
  React.Children.map(children, (child: React.ReactElement<SelectItemProps>) => {
    valueToNameMapping.set(
      child.props.value,
      (getNodeText(child) ?? child.props.value) as string,
    );
  });
  return valueToNameMapping;
}

export function getFilteredOptions(
  searchQuery: string,
  children: React.ReactElement[],
): React.ReactElement[] {
  return React.Children.map(children, (child) => {
    const optionText = (getNodeText(child) ?? child.props.value) as string;
    if (optionText.toLowerCase().includes(searchQuery.toLowerCase()))
      return child;
  });
}

export const getSelectButtonColors = (
  hasSelection: boolean,
  isDisabled: boolean,
  hasError = false,
) => {
  return cx(
    isDisabled
      ? 'bg-revving-background-subtle dark:bg-darkRevving-background-subtle'
      : 'bg-revving-background dark:bg-darkRevving-background',
    !isDisabled &&
      'hover:bg-revving-background-muted dark:hover:bg-darkRevving-background-muted',
    hasSelection
      ? 'text-revving-content-emphasis dark:text-darkRevving-content-emphasis'
      : 'text-revving-content dark:text-darkRevving-content',
    isDisabled &&
      'text-revving-content-subtle dark:text-darkRevving-content-subtle',
    hasError &&
      'text-red-500 placeholder:text-red-500 dark:text-red-500 dark:placeholder:text-red-500',
    hasError
      ? 'border-red-500 dark:border-red-500'
      : 'border-revving-border dark:border-darkRevving-border',
  );
};

export function hasValue<T>(value: T | null | undefined) {
  return value !== null && value !== undefined && value !== '';
}

export const isValueInArray = (value: any, array: any[]): boolean => {
  for (let i = 0; i < array.length; i++) {
    if (array[i] === value) {
      return true;
    }
  }
  return false;
};
